import React, { useEffect } from 'react';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const tokens = [
  {
    id: 'polygon',
    name: 'Pol',
    description: 'POLYGON Token',
    icon: '/assets/matic-token.svg'
  },
  {
    id: 'kaxaa',
    name: 'KAX',
    description: 'KAXAA Token',
    icon: '/assets/token-icon.svg'
  },
  {
    id: 'usdc',
    name: 'USDC',
    description: 'USD Coin',
    icon: '/assets/usd-token.svg'
  }
];

export default function DepositCurrency() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Deposit Currency - KAXAA Wallet";
  }, []);

  const handleCardClick = (tokenId) => {
    navigate(`/deposit/${tokenId}`);
  };

  return (
    <div className='app-container'>
      <div className="deposit-currency-page">
        <div className="container mx-auto px-1 py-4 max-w-4xl">
          <div className="account-card">
            <div className="card-title mb-4 d-flex align-items-center gap-3">
              <div className='flex-1 text-start'>
                <h2 className="mb-1"><span>Deposit</span></h2>
                <p className="m-0">Please choose a currency you want to deposit</p>
              </div>
              <div className='btn btn-icon' onClick={() => { }}>

              </div>
            </div>

            <Row className="my-5 justify-content-center g-3">
              {tokens.map((token) => (
                <Col md="4" xs="12" key={token.id}>
                  <Card
                    className="deposit-currency-card text-center cursor-pointer"
                    onClick={() => handleCardClick(token.id)}
                  >
                    <CardBody>
                      <div className="icon">
                        <img src={token.icon} alt={`${token.name} icon`} width={40} />
                      </div>
                      <h5>{token.name}</h5>
                      <p>{token.description}</p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>

            <div className="text-center">
              <p className="text-danger text-sm m-0">
                WARNING: This wallet only supports POLYGON (POL) Network tokens.
                If you mistakenly send tokens to a wrong address, or send them using
                the wrong network, the tokens will not be recoverable and will
                effectively be lost.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
}
